import { FC, useContext, useEffect } from "react";
import { usePostHog } from "posthog-js/react";

import { AppContext } from "contexts";
import useTermlyConsent from "hooks/useTermlyConsent";

const PostHogConsentManager: FC = () => {
  const posthog = usePostHog();
  const termlyConsent = useTermlyConsent(["analytics"]);
  const { user } = useContext(AppContext);

  useEffect(() => {
    if (termlyConsent) {
      posthog?.opt_in_capturing();
      posthog?.set_config({
        disable_session_recording: false,
      });
      if (!!user && user.userId) {
        posthog?.identify(user.userId.toString());
      }
    } else {
      posthog?.opt_out_capturing();
      posthog?.set_config({
        disable_session_recording: true,
      });
    }
  }, [termlyConsent, posthog, user]);

  return null;
};

export default PostHogConsentManager;
